import React, { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { BiLogoApple, BiLogoPlayStore } from 'react-icons/bi'

const Review: React.FC = () => {
  const [t] = useTranslation('global')

  // App store review links
  const iosAppReviewLink =
    'https://apps.apple.com/es/app/ciclogreen-movilidad/id1326776999?action=write-review'
  const androidAppReviewLink =
    'https://play.google.com/store/apps/details?id=es.inmovens.ciclogreen&showAllReviews=true'
  const webLink = 'https://www.ciclogreen.com/'

  useEffect(() => {
    const detectPlatform = (userAgent: string) => {
      const ua = userAgent.toLowerCase()
      if (/iphone|ipad|ipod|ios/.test(ua)) return 'ios'
      if (/android/.test(ua)) return 'android'
      return 'other'
    }

    const appendParams = (url: string, params: Record<string, string>) => {
      try {
        const urlObj = new URL(url)
        Object.entries(params).forEach(([key, value]) => {
          if (value != null && value !== '') {
            urlObj.searchParams.set(key, value)
          }
        })
        return urlObj.toString()
      } catch {
        return url
      }
    }

    const urlParams = new URLSearchParams(window.location.search)

    const trackingParams: Record<string, string> = {}
    urlParams.forEach((value, key) => {
      if (key.startsWith('utm_') || key === 'qr_id') {
        trackingParams[key] = value
      }
    })

    const platform = detectPlatform(navigator.userAgent)
    let targetUrl: string | null = null

    if (platform === 'ios') {
      targetUrl = appendParams(iosAppReviewLink, trackingParams)
    } else if (platform === 'android') {
      targetUrl = appendParams(androidAppReviewLink, trackingParams)
    }

    const iosLinkEl = document.getElementById('iosLink') as HTMLAnchorElement
    const androidLinkEl = document.getElementById(
      'androidLink',
    ) as HTMLAnchorElement
    const webLinkEl = document.getElementById('webLink') as HTMLAnchorElement

    if (iosLinkEl)
      iosLinkEl.href = appendParams(iosAppReviewLink, trackingParams)
    if (androidLinkEl)
      androidLinkEl.href = appendParams(androidAppReviewLink, trackingParams)
    if (webLinkEl) webLinkEl.href = appendParams(webLink, trackingParams)

    const msgEl = document.getElementById('msg')
    if (msgEl) {
      msgEl.textContent =
        platform === 'ios'
          ? 'Destino: Valoración App Store'
          : platform === 'android'
          ? 'Destino: Valoración Google Play'
          : 'Selecciona tu plataforma para continuar'
    }

    let redirectTimer: number | null = null
    let fallbackTimer: number | null = null

    if (targetUrl) {
      redirectTimer = window.setTimeout(() => {
        window.location.replace(targetUrl as string)
      }, 500)

      fallbackTimer = window.setTimeout(() => {
        window.location.href = targetUrl as string
      }, 1500)
    }

    return () => {
      if (redirectTimer) clearTimeout(redirectTimer)
      if (fallbackTimer) clearTimeout(fallbackTimer)
    }
  }, [])

  return (
    <div className="h-[100dvh] flex items-center justify-center bg-gray-50 overflow-hidden px-4">
      <div className="max-w-md w-full bg-white p-6 rounded-xl shadow-md space-y-4">
        <div className="flex justify-center">
          <img
            alt="Ciclogreen Logo"
            src={`${process.env.REACT_APP_URL_S3}/images/logo.png`}
            width={180}
            height={28}
            className="mx-auto"
          />
        </div>
        <div>
          <h1 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {t('qr.redirecting')}
          </h1>
          <p className="mt-2 text-center text-sm text-gray-600">
            {t('qr.automaticRedirect')}
          </p>
        </div>
        <div className="mt-8 space-y-6">
          <div className="flex flex-col justify-center gap-4">
            <a
              id="iosLink"
              href="#"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              rel="noopener"
            >
              <div className="flex items-center gap-2">
                <BiLogoApple />
                App Store
              </div>
            </a>
            <a
              id="androidLink"
              href="#"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              rel="noopener"
            >
              <div className="flex items-center gap-2">
                <BiLogoPlayStore />
                Google Play
              </div>
            </a>
            <a
              id="webLink"
              href="#"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-grey bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              rel="noopener"
            >
              Web
            </a>
          </div>
        </div>
        <p id="msg" className="mt-2 text-center text-sm text-gray-500"></p>
      </div>
    </div>
  )
}

export default Review
